module.exports = __webpack_public_path__ + "img/deploy-short.73de835e.png";